﻿/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 251029   
    This script contains functions used to create a navigation grid for tables
*/
'use strict';
import { getTag } from './ctssHtml.js';

// private functions

const getGridState = (params) => {
    const { pageSize, currentIdx, totalRows } = params.getGridStateFn();
    const totalPages = totalRows > pageSize ? Math.ceil(totalRows / pageSize) : 1;
    return { currentIdx, pageSize, totalPages, totalRows };
};

// public functions

//const getGridNavBar = (params) => {
//    /* This function will create a navigation bar to be used with tables

//        params                
//            getRowsFn:          Function to display rows.
//            getGridStateFn:     Function returning currentIdx, pageSize, totalRows
//            name:               Name of nav bar
//            useNavBtns:         true/false defaults to true
//            usePages:           true/fasle defaults to true                
//    */
//    let content = '<ul class="pagination">';

//    if (params.getGridStateFn === undefined) return;

//    if ((params.useNavBtns === undefined) || (params.useNavBtns === true)) {
//        content += getTag({
//            tag: 'li',
//            content: getTag({
//                tag: 'a',
//                attrs: {
//                    id: 'aFirst',
//                    href: "#",
//                    cssClass: "fa fa-fast-backward",
//                }
//            })
//        });
//        content += getTag({
//            tag: 'li',
//            content: getTag({
//                tag: 'a',
//                attrs: {
//                    id: 'aPrior',
//                    href: "#",
//                    cssClass: "fa fa-step-backward",
//                }
//            })
//        });        
//    }

//    if ((params.usePages === undefined) || (params.usePages === true)) {
//        var gridState = getGridState(params);
//        for (let i = 0, l = gridState.totalPages; i < l; i++) {
//            let currPage = i + 1;
//            let anchor = getTag({
//                tag: 'a',
//                content: currPage,
//                attrs: {
//                    id: 'a'+i,
//                    href: "#",
//                }
//            });
//            content += getTag({
//                tag: 'li',
//                content: anchor,
//                attrs: {
//                    id: 'p' + currPage,
//                    cssClass: (i == 0) ? 'active' : undefined
//                }
//            });
//        }
//    }

//    if ((params.useNavBtns === undefined) || (params.useNavBtns === true)) {
//        content += getTag({
//            tag: 'li',
//            content: getTag({
//                tag: 'a',
//                attrs: {
//                    id: 'aNext',
//                    href: "#",
//                    cssClass: "fa fa-step-forward"
//                }
//            })
//        });
//        content += getTag({
//            tag: 'li',
//            content: getTag({
//                tag: 'a',
//                attrs: {
//                    id: 'aLast',
//                    href: "#",
//                    cssClass: "fa fa-fast-forward"
//                }
//            })
//        });
//    }

//    content += '</ul>';
//    $((params.name === undefined) ? '#gridNavBar' : params.name).empty().append(content);

//    // Attach click handlers for pages

//    if ((params.usePages === undefined) || (params.usePages === true)) {

//        for (let i = 0; i < gridState.totalPages; i++) {
//            $(`#a${i}`).off('click').on('click', () => {
//                params.navType = 'page';
//                params.pageIdx = i * gridState.pageSize;
//                return gridNavBarClick(params);
//            });
//        }
//    }

////    // Attach click handlers for nav buttons

//    if ((params.useNavBtns === undefined) || (params.useNavBtns === true)) {
//        $('#aFirst').off('click').on('click', () => {
//            params.navType = 'first';
//            return gridNavBarClick(params);
//        });

//        $('#aPrior').off('click').on('click', () => {
//            params.navType = 'prior';
//            return gridNavBarClick(params);
//        });

//        $('#aNext').off('click').on('click', () => {
//            params.navType = 'next';
//            return gridNavBarClick(params);
//        });

//        $('#aLast').off('click').on('click', () => {
//            params.navType = 'last';
//            return gridNavBarClick(params);
//        });
//    }            
//}

const getGridNavBar = params => {
    /*
        Creates a navigation bar for tables.

        params                
            getRowsFn:      Function to display rows.
            getGridStateFn: Function returning currentIdx, pageSize, totalRows
            name:           Name of nav bar
            useNavBtns:     true/false, defaults to true
            usePages:       true/false, defaults to true                
    */
    if (!params.getGridStateFn) return;

    let content = '<ul class="pagination">';

    const useNavBtns = params.useNavBtns !== false;
    const usePages = params.usePages !== false;

    if (useNavBtns) {
        ['aFirst', 'aPrior'].forEach((id, idx) => {
            const icon = idx === 0 ? 'fa fa-fast-backward' : 'fa fa-step-backward';
            content += getTag({
                tag: 'li',
                content: getTag({
                    tag: 'a',
                    attrs: { id, href: "#", cssClass: icon }
                })
            });
        });
    }

    let gridState;
    if (usePages) {
        gridState = getGridState(params);
        for (let i = 0; i < gridState.totalPages; i++) {
            const currPage = i + 1;
            const anchor = getTag({
                tag: 'a',
                content: currPage,
                attrs: { id: `a${i}`, href: "#" }
            });
            content += getTag({
                tag: 'li',
                content: anchor,
                attrs: {
                    id: `p${currPage}`,
                    cssClass: i === 0 ? 'active' : undefined
                }
            });
        }
    }

    if (useNavBtns) {
        ['aNext', 'aLast'].forEach((id, idx) => {
            const icon = idx === 0 ? 'fa fa-step-forward' : 'fa fa-fast-forward';
            content += getTag({
                tag: 'li',
                content: getTag({
                    tag: 'a',
                    attrs: { id, href: "#", cssClass: icon }
                })
            });
        });
    }

    const navBarSelector = params.name ?? '#gridNavBar';
    $(navBarSelector).empty().append(content);

    // Attach click handlers for pages
    if (usePages && gridState) {
        for (let i = 0; i < gridState.totalPages; i++) {
            $(`#a${i}`).off('click').on('click', () => {
                params.navType = 'page';
                params.pageIdx = i * gridState.pageSize;
                return gridNavBarClick(params);
            });
        }
    }

    // Attach click handlers for nav buttons
    if (useNavBtns) {
        [
            { id: '#aFirst', type: 'first' },
            { id: '#aPrior', type: 'prior' },
            { id: '#aNext', type: 'next' },
            { id: '#aLast', type: 'last' }
        ].forEach(({ id, type }) => {
            $(id).off('click').on('click', () => {
                params.navType = type;
                return gridNavBarClick(params);
            });
        });
    }
};
const gridNavBarClick = params => {
    const gridState = getGridState(params);
    const { currentIdx, pageSize, totalRows } = gridState;
    let currentPage = Math.floor(currentIdx / pageSize) + 1;

    $(`#p${currentPage}`).removeClass('active');

    let pageIdx;
    switch (params.navType) {
        case "page": {
            currentPage = Math.floor(params.pageIdx / pageSize) + 1;
            params.getRowFn?.({ totalRows, pageIdx: params.pageIdx });
            break;
        }
        case "first": {
            currentPage = 1;
            params.getRowFn?.({ totalRows, pageIdx: 0 });
            break;
        }
        case "prior": {
            pageIdx = Math.max(0, currentIdx - pageSize);
            currentPage = Math.floor(pageIdx / pageSize) + 1;
            params.getRowFn?.({ totalRows, pageIdx });
            break;
        }
        case "next": {
            pageIdx = currentIdx + pageSize >= totalRows ? currentIdx : currentIdx + pageSize;
            currentPage = Math.floor(pageIdx / pageSize) + 1;
            params.getRowFn?.({ totalRows, pageIdx });
            break;
        }
        case "last": {
            pageIdx = Math.floor((totalRows - 1) / pageSize) * pageSize;
            currentPage = Math.floor(pageIdx / pageSize) + 1;
            params.getRowFn?.({ totalRows, pageIdx });
            break;
        }
        default:
            break;
    }

    $(`#p${currentPage}`).addClass('active');
};

export {
    getGridNavBar,
    gridNavBarClick
}


